import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-roles-edit-modal',
  templateUrl: './roles-edit-modal.component.html',
  styleUrls: ['./roles-edit-modal.component.css']
})
export class RolesEditModalComponent implements OnInit {

  @Input() roles: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();


  ngOnInit(): void {

  }

  onSaveRole(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }

}
